import { CONFIG } from '../main/config';
import { findParent, findParentNodeType } from '../tools/helpers';
import BfvImage from './../main/BfvImage';
import { initSingleModule } from '../main/initModules';

class BfvInfothek {
  constructor(options = {}) {
    this.$root = options.element;
    this.Vue = window.divae.Vue;
    this.$sortFilter = this.$root.querySelector('.js-sort-dropdown-wrapper');
    this.resultComponentInitalData = {
      wrapperClass: this,
      labels: [],
      results: [],
      isInitialCall: false,
      nextResults: null,
    };
    this.filterComponentInitialData = {
      wrapperClass: this,
      selectedFilter: {},
    };
    this.pageItemCount = 10;
    this.initalFilter = {};
    this.initalParams = {
      from: 0,
      size: this.pageItemCount,
      sortField: 'date',
      fromDate: null,
      toDate: null,
      textFilter: null,
    };

    this.sortValue = 'desc';
    if (this.$sortFilter !== null && this.$sortFilter.hasAttribute('data-initial-sort')) {
      this.sortValue = this.$sortFilter.getAttribute('data-initial-sort');
      Object.assign(this.initalParams, { sortType: this.sortValue });
    }

    this.apiConfig = {
      route: null,
      filter: Object.assign({}, this.initalFilter),
      params: Object.assign({}, this.initalParams),
    };
    this.$totalHits = this.$root.querySelector('.js-total-hits');
    this.$filter = this.$root.querySelectorAll('.js-filter > div');
    this.$textFilters = this.$root.querySelectorAll('.js-text-input');

    this.data = null;

    this.initVueComponents(options.vue);
    this.bindFilterEvents();
  }

  initVueComponents(vueOptions) {
    this.vueResultComponent = new this.Vue({
      el: vueOptions.results.el,
      template: vueOptions.results.template,
      data: Object.assign({}, this.resultComponentInitalData, { isInitialCall: true }),
      props: [],
      methods: {
        loadMore() {
          this.wrapperClass.loadMore();
        },
        updateData(newData) {
          Object.assign(this.$data, this.wrapperClass.resultComponentInitalData, newData);
        },
      },
      updated() {
        this.$nextTick(() => {
          const resultArray = this.$refs.result;
          if (resultArray) {
            this.wrapperClass.loadJS(resultArray);
            this.wrapperClass.loadImages(resultArray);
          }
        });
      },
    });

    this.vueFilterComponent = new this.Vue({
      el: vueOptions.selectedFilter.el,
      template: vueOptions.selectedFilter.template,
      data: Object.assign({}, this.filterComponentInitialData),
      methods: {
        resetAllFilter(evt) {
          evt.preventDefault();
          const parent = this.wrapperClass;
          const $selectOption = document.getElementsByClassName('js-text-input')[0];
          if ($selectOption) {
            $selectOption.value = '';
          }

          parent.apiConfig.filter = Object.assign({}, parent.initalFilter);
          parent.apiConfig.params = Object.assign({}, parent.initalParams);
          parent.updateFilterData();
          parent.loadData();

          Array.prototype.slice.call(parent.$filter).forEach(($filter) => {
            const event = document.createEvent('CustomEvent');
            event.initCustomEvent(
              CONFIG.events.BFV_RESET_FILTER,
              false,
              false,
              CONFIG.eventstData.BFV_RESET_FILTER__ALL,
            );
            $filter.dispatchEvent(event);
          });
        },
        resetSingleFilter(value, key) {
          const parent = this.wrapperClass;
          let $filterWrapper = null;

          if (key !== 'date' && key !== 'textFilter') {
            const $selectOption = document.querySelector(`[value="${value}"]`);
            const $filter = findParentNodeType($selectOption, 'select');
            $filterWrapper = findParent($filter, 'bfv-multiselect');

            const arrayNameToRemoveFrom = $filter.getAttribute('name');
            const objElemToRemove = parent.apiConfig.filter[arrayNameToRemoveFrom]
              .findIndex(obj => obj.value === value);

            if (objElemToRemove > -1) {
              parent.apiConfig.filter[arrayNameToRemoveFrom].splice(objElemToRemove, 1);
            }

            if (!parent.apiConfig.filter[arrayNameToRemoveFrom].length) {
              delete parent.apiConfig.filter[arrayNameToRemoveFrom];
            }

            // remove date filter
          } else if (key === 'date') {
            $filterWrapper = parent.$root.querySelector('[data-module="BfvDatepicker"]');
            const objElemToRemove = parent.apiConfig.filter[key]
              .findIndex(obj => obj.value === value);

            if (objElemToRemove > -1) {
              parent.apiConfig.filter[key].splice(objElemToRemove, 1);
            }

            if (parent.apiConfig.filter[key].length) {
              delete parent.apiConfig.filter[key];
            }

            delete parent.apiConfig.filter.date;
            parent.apiConfig.params.fromDate = null;
            parent.apiConfig.params.toDate = null;

            // remove text filter
          } else if (key === 'textFilter') {
            const $selectOption = document.getElementsByClassName('js-text-input')[0];

            $selectOption.value = '';
            delete parent.apiConfig.filter.textFilter;
            parent.apiConfig.params.textFilter = null;
          }

          parent.updateFilterData();
          parent.loadData();

          const event = document.createEvent('CustomEvent');
          event.initCustomEvent(CONFIG.events.BFV_RESET_FILTER, false, false, {
            value,
          });

          if ($filterWrapper) {
            $filterWrapper.dispatchEvent(event);
          }
        },
        updateData(newData) {
          Object.assign(this.$data, this.wrapperClass.filterComponentInitialData, { selectedFilter: newData });
        },
      },
    });
  }

  bindFilterEvents() {
    // data for datepicker on change
    this.$root.addEventListener(CONFIG.events.BFV_DATEPICKER_CHANGED, (event) => {
      const dates = event.detail.selectedDates;
      this.apiConfig.params.fromDate = `${event.detail.instance.formatDate(dates[0], 'dmY')}`;
      this.apiConfig.params.toDate = `${event.detail.instance.formatDate(dates[1], 'dmY')}`;
      this.apiConfig.params.from = 0;

      this.apiConfig.filter.date = [{
        value: event.detail.dateStr[0],
        label: event.detail.dateStr[0],
      }];

      this.loadData();
      this.updateFilterData();
    });

    // data for multiselect on change
    this.$root.addEventListener(CONFIG.events.BFV_MULTISELECT_CLICKED, (event) => {
      if (event.detail.selectedOptions.length) {
        this.apiConfig.filter[event.detail.name] = event.detail.selectedOptions;
      } else {
        delete this.apiConfig.filter[event.detail.name];
      }
      this.apiConfig.params.from = 0;
      this.loadData();
      this.updateFilterData();
    });

    // data for text input
    this.$textFilters.forEach(($textFilter) => {
      $textFilter.addEventListener(CONFIG.events.BFV_TEXTINPUT_CHANGED, (event) => {
        if (event.detail.value.length && (event.target.getAttribute('data-threshold') < event.detail.value.length)) {
          const val = event.detail.value;
          this.apiConfig.params.textFilter = event.detail.value;

          if (event.detail.value.length + 1 > Number($textFilter.getAttribute('maxlength'))) {

            this.apiConfig.filter.textFilter = [{
              value: val,
              label: val,
            }];
          } else {
            this.apiConfig.filter.textFilter = [{
              value: event.detail.value,
              label: event.detail.value,
            }];
          }
        } else {
          this.apiConfig.params.textFilter = null;
          delete this.apiConfig.filter.textFilter;
        }

        this.loadData();
        this.updateFilterData();

      });
    });
  }

  updateFilterData() {
    this.vueFilterComponent.updateData(this.apiConfig.filter);
  }

  updateTotalHits() {
    if (this.data.totalHits) {
      this.$totalHits.innerText = this.data.totalHits;
      this.$totalHits.classList.add('visible');
    } else {
      this.$totalHits.classList.remove('visible');
    }
  }

  loadMore() {
    this.apiConfig.params.from += this.pageItemCount;
    this.loadData(true);
  }

  generateApiRouteWithParams(loadNextResults) {
    let route = `${this.apiConfig.route}`;

    if (loadNextResults && this.data.nextResults) {
      return `${route}${this.data.nextResults}`;
    }

    const routeArray = [];

    // Params
    Object.keys(this.apiConfig.params).forEach((key) => {
      if (this.apiConfig.params[key] !== null) {
        routeArray.push(`${key}=${this.apiConfig.params[key]}`);
      }
    });

    // Filter
    Object.keys(this.apiConfig.filter).forEach((key) => {
      if (key !== 'date' && key !== 'textFilter') {
        const filterValues = this.apiConfig.filter[key].map(filter => filter.value);

        routeArray.push(`${key}=${filterValues.join(',')}`);
      }
    });

    route += `?${routeArray.join('&')}`;

    return route;
  }

  loadData(loadNextResults = false) {
    if (!this.apiConfig.route) {
      console.error('Please specify an API Route - Attribute is missing in "apiConfig" Obejct');
      return;
    }

    const getRouteWithParams = this.generateApiRouteWithParams(loadNextResults);

    window.divae.restApi
      .loadData(getRouteWithParams)
      .then((_response) => {
        const response = _response;
        if (loadNextResults) {
          response.results = this.data.results.concat(response.results);
        }
        this.data = response;
        this.dataLoaded();
      });
  }

  loadJS(resultArray) {
    resultArray.forEach(($result) => {
      const $moduleToInit = $result.querySelectorAll('[data-module]');
      const $JSmodules = [...$moduleToInit]
        .filter((module) => {
          let $jsMod;
          if (!module.classList.contains('bfv-image__loader')) {
            $jsMod = module;
          }
          return $jsMod;
        });

      $JSmodules.forEach(($element) => {
        initSingleModule({ element: $element, name: $element.getAttribute(['data-module']) });
      });
    });
  }

  loadImages(resultArray) {
    resultArray.forEach(($result) => {
      const $image = $result.querySelector('.bfv-image__loader[data-module="BfvImage"]');

      if ($image === null) {
        return;
      }

      if (!$image.classList.contains('bfv-image--load-finished') &&
        !$image.classList.contains('bfv-image--load-init') && !$image.classList.contains('bfv-image--loading')) {
        const newImage = new BfvImage({ element: $image });
        newImage.disableAutoLoad = true;
        newImage.init();
      }

      const event = document.createEvent('event');
      event.initEvent(CONFIG.events.BFV_IMAGE_LOAD, false, true);
      $image.dispatchEvent(event);
    });
  }

  dataLoaded() {
    // will be overwritten by child-class
  }
}

export default BfvInfothek;



// WEBPACK FOOTER //
// ./src/javascript/infothek/main.js